export default function displayValue(value, enums) {
    const item = enums.find(obj => obj.value === value);
    return item ? item.name : '';
}